import { getIsOrangeComboButtonEnabled, getIsTariffAccumsFttbDivideEnabled } from '@beef/elk-common/utils';
import { ActionCreator } from "../../../../../store/actions";
import { ConnectionBlockActionCreator } from "../actions";
import { selectIsConvergent, selectIsFTTBUser, selectIsMobileUser } from "../selectors";
var onMountTariff = function onMountTariff() {
  return function (dispatch, getState) {
    var state = getState();
    var isMobileUser = selectIsMobileUser(state);
    var isFTTBUser = selectIsFTTBUser(state);
    var isConvergent = selectIsConvergent(state);
    dispatch(ConnectionBlockActionCreator.fetchBalance());
    dispatch(ConnectionBlockActionCreator.fetchFubGroups());
    if (!isFTTBUser && getIsOrangeComboButtonEnabled()) {
      dispatch(ActionCreator.fetchOrangeComboInfo());
    }
    if (getIsTariffAccumsFttbDivideEnabled()) {
      if (!isFTTBUser) {
        dispatch(ConnectionBlockActionCreator.fetchTariff());
        dispatch(ConnectionBlockActionCreator.fetchAccumulators());
        dispatch(ConnectionBlockActionCreator.fetchConnectionPrice());
      }
      if (isConvergent) {
        dispatch(ConnectionBlockActionCreator.fetchConvergent());
      }
    } else {
      if (isMobileUser) {
        dispatch(ConnectionBlockActionCreator.fetchMobileConnection());
        dispatch(ConnectionBlockActionCreator.fetchConnectionPrice());
      }
      if (isConvergent) {
        dispatch(ConnectionBlockActionCreator.fetchMobileConnection());
        dispatch(ConnectionBlockActionCreator.fetchConnectionPrice());
        dispatch(ConnectionBlockActionCreator.fetchConvergent());
      }
    }
    if (isFTTBUser) {
      dispatch(ConnectionBlockActionCreator.fetchFTTBConnection());
    }
  };
};
export var ActionCreatorTariff = {
  onMountTariff: onMountTariff
};